import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import LockedButtonOverlay from './LockedButtonOverlay';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { AvailableDisabledFeatures } from '../popups/PopupFeatureDisabled';
import sounds from 'src/lib/sounds';
import { isPlatformGuest } from '../../lib/utils';
import { GCInstant as platform } from 'src/lib/gcinstant';
import { promptLINELoginNew } from '../guest/guest.sequence';

const ui = uiConfig.buruburu.menu;

export type MenuActionType =
  | 'encyclopedia'
  | 'petCollection'
  | 'growthJournal'
  | 'familyTree'
  | 'mission'
  | 'catalog'
  | 'decor'
  | 'profile'
  | 'settings'
  | 'previewStage';

type MenuActionButtonOpts<TDisabled = boolean> = TDisabled extends false
  ? {
      type: MenuActionType;
      onSelect: (selection: MenuActionType) => Promise<void>;
      isDisabled?: TDisabled;
    }
  : {
      type: AvailableDisabledFeatures;
      onSelect: (selection: MenuActionType) => Promise<void>;
      isDisabled?: TDisabled;
    };

export default class MenuActionButton extends ButtonScaleViewWithText {
  constructor(private opts: MenuActionButtonOpts) {
    super({
      ...ui.menuButton,
      icon: ui.icons[opts.type as keyof typeof ui.icons],
      localeText: () => i18n(`mainMenu.${opts.type}`),
      tracking: { feature: 'mainMenu', $subFeature: opts.type },
    });

    this.icon?.updateOpts({ scaleMethod: 'contain' });

    if (opts.isDisabled) {
      const { width, height } = this.style;
      this.addSubview(new LockedButtonOverlay({ width, height }));
    }
  }

  public onClick = async () => {
    // Show feature disabled popup
    if (this.opts.isDisabled) {
      sounds.sfx.play('ok');

      if (this.opts.type === 'profile' && isPlatformGuest(platform)) {
        await promptLINELoginNew('profile');

        return;
      }

      await openPopupPromise('popupFeatureDisabled', {
        feature: this.opts.type,
        origin: 'hud',
      });
    } else {
      await this.opts.onSelect(this.opts.type as MenuActionType);
    }
  };
}
